import { Navigate, useSearch } from '@tanstack/react-router';

import { firstVisibleSettingsPath } from '@apps/web/components/settings/settings_nav_items';
import { SettingsLoadingState } from '@apps/web/components/settings/settings_page_shell';
import { useSettingsGates } from '@apps/web/components/settings/use_settings_gates';

// Role-aware default landing for `/settings` (no tab): admins go to the
// Organization section, everyone else to personal notifications. Waits for the
// gates to load so admins aren't sent to notifications on the transient false.
export function SettingsIndexRedirect() {
    const { gates, isLoading } = useSettingsGates();
    const search = useSearch({ from: '/_app/settings/' });
    if (isLoading) {
        return <SettingsLoadingState />;
    }
    if (gates.canManageOrgSettings) {
        const to =
            firstVisibleSettingsPath(gates, 'org') ?? '/settings/team-members';
        return <Navigate to={to} replace={true} />;
    }
    return (
        <Navigate
            to="/settings/notifications"
            replace={true}
            search={{
                organizationId: search.organizationId,
                unsubscribeEmailType: search.unsubscribeEmailType,
                source: search.source,
            }}
        />
    );
}
